'use client';
import { Node, ReactNodeViewRenderer } from "@tiptap/react";
import { AssetType, openAssetHQType } from "../../types.js";
import { ImageUploadBuilder } from "./view/ImageUpload.js";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    imageUpload: {
      setImageUpload: (type?: AssetType) => ReturnType;
    };
  }
}

export const ImageUpload = Node.create({
  name: "imageUpload",

  isolating: true,

  defining: true,

  group: "block",

  draggable: true,

  selectable: true,

  inline: false,

  parseHTML() {
    return [
      {
        tag: `div[data-type="${this.name}"]`,
      },
    ];
  },

  renderHTML() {
    return ["div", { "data-type": this.name }];
  },

  addAttributes() {
    return {
      type: { default: null },
    };
  },
  addCommands() {
    return {
      setImageUpload:
        (type?: AssetType) =>
        ({ commands }) => {
          return commands.insertContent({
            type: "imageUpload",
            attrs: {
              type,
            },
          });
        },
    };
  },

  addNodeView() {
    const openAssetHQHandler = this.options
      .openAssetHQHandler as openAssetHQType;
    return ReactNodeViewRenderer(ImageUploadBuilder(openAssetHQHandler));
  },
});

export default ImageUpload;
